import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { contentRelatedIds } from 'src/lib/fetchers/content-fetchers';

type Props = {
  data: IdsAssocitedToContent;
  isLoading: boolean;
};
export const CONTENT_IDS_QUERY_KEY = (contentId: string) => 'content-ids-' + contentId;
const useIDsAssociatedWithContent = ({
  contentId,
  enabled,
}: {
  enabled?: boolean;
  contentId: string;
}): Props => {
  const { data, isLoading } = useQuery(
    [
      CONTENT_IDS_QUERY_KEY(contentId),
      {
        contentId,
      },
    ],
    contentRelatedIds,
    {
      retry: false,
      refetchOnWindowFocus: false,
      enabled: enabled !== false && !!contentId,
      staleTime: 1000 * 60 * 60,
    },
  );
  const Data = useMemo(() => {
    return new IdsAssocitedToContent(data?.data);
  }, [data]);
  return {
    data: Data,
    isLoading,
  };
};

export default useIDsAssociatedWithContent;

export class IdsAssocitedToContent {
  _id: string;
  type: string;
  title: string;
  slug: string;
  programId: AssociatedIdsObject;
  subjectId: AssociatedIdsObject;
  chapterId: AssociatedIdsObject;
  topicId: AssociatedIdsObject;
  constructor(data: any) {
    data = data || {};
    this._id = data?._id || '';
    this.type = data?.type || '';
    this.title = data?.title || '';
    this.slug = data?.slug || '';
    this.programId = new AssociatedIdsObject(data?.programId || {});
    this.subjectId = new AssociatedIdsObject(data?.subjectId || {});
    this.chapterId = new AssociatedIdsObject(data?.chapterId || {});
    this.topicId = new AssociatedIdsObject(data?.topicId || {});
  }
}

export class AssociatedIdsObject {
  _id: string;
  name: string;
  slug: string;
  constructor(data: any) {
    data = data || {};
    this._id = data?._id || '';
    this.name = data?.name || '';
    this.slug = data?.slug || '';
  }
}
